"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.iconSizeConfig = exports.borderRadiusConfig = void 0;
/**
 *  Border Radius Size Config
 */
var borderRadiusConfig = exports.borderRadiusConfig = {
  s: '2px',
  m: '4px',
  l: '6px'
};
/**
 *  Icon Size Config
 */
var iconSizeConfig = exports.iconSizeConfig = {
  large: {
    height: "var(--spacing-global-space7)",
    width: "var(--spacing-global-space7)"
  },
  medium: {
    height: "var(--spacing-global-space6)",
    width: "var(--spacing-global-space6)"
  },
  small: {
    height: "var(--spacing-global-space5)",
    width: "var(--spacing-global-space5)"
  }
};